const Footer = () => {
  return (
    <footer className="fixed bottom-0 left-0 w-full bg-gray-900 text-white py-4 text-center shadow-lg">
      <p>&copy; {new Date().getFullYear()} TruckTek Pvt Ltd. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
